import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface IMessageTemplateResponse {
    message: string;
    data: IMessageTemplate[];
  }
  
  export interface IMessageTemplate {
    _id: string;
    name: string;
    type: string;
    subjectLine: string;
    content: string[];
    noOfContent: number;
    trigger: string;
    isActive: boolean;
    availableVariables: string[];
    subscriberId?: string;
    baseTemplateId?: string;
    __v?: number;
  }

@Injectable({
  providedIn: 'root'
})
export class MessageTemplateService {

  constructor(private http: HttpClient) {}

  getAllMessageTemplates(): Observable<IMessageTemplateResponse> {
    return this.http.get<IMessageTemplateResponse>(`${environment.apiUrl}/message-templates/`);
  }

  createMessageTemplate(messageTemplate: IMessageTemplate): Observable<IMessageTemplate> {
    return this.http.post<IMessageTemplate>(`${environment.apiUrl}/message-templates/create`, messageTemplate);
  }

  updateMessageTemplate(id: string, messageTemplate: IMessageTemplate): Observable<IMessageTemplate> {
    return this.http.put<IMessageTemplate>(`${environment.apiUrl}/message-templates/${id}`, messageTemplate);
  }
  
  getMessageTemplateByName(name: string): Observable<IMessageTemplate> {
    return this.http.get<IMessageTemplate>(`${environment.apiUrl}/message-templates/${name}`);
  }
  
  
}